// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"eX","speechCardBox":"eX","speech-img-box":"eY","speechImgBox":"eY","card-content":"eZ","cardContent":"eZ","card-src":"e0","cardSrc":"e0"};